export interface UserModel {
    id?: string;
    uid: string;
    displayName?: string;
    email?: string;
    emailVerified?: string;
    lastSignIn?: any;
    lastSeen?: any;
    phoneNumber?: string;
    photoURL?: string;
    createdAt?: any;
}

export interface UserProfileModel extends UserModel {
    lastupdatedAt?: any;
    deck_count?: number;
    orig_email: string;
    last_email: string;
    all_emails: string[];
    notificationPreferences?: NotificationPreferences;
}

export interface NotificationPreferences {
    dueDecks: NotificationTypes[];
    learningReminders: NotificationTypes[];
    optOutAll: boolean;
}

export enum NotificationTypes {
    email  = 'EMAIL',
    sms    = 'SMS',
    slack  = 'SLACK'
}
